import React from 'react';
import { Main } from './components';

interface ClientPortalScoreAndMetricsPageProps {}

export const ClientPortalScoreAndMetricsPage: React.FC<ClientPortalScoreAndMetricsPageProps> = () => {
  return <Main />;
};
